import type { GridPadding } from './types';

export const CONFERENCE_PARTICIPANTS_MOCK = [
	{
		id: 'p-1',
		name: 'Andrey Ivanov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-1-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-1-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-2',
		name: 'Konstantin Konstantinovsky',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-2-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-2-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-3',
		name: 'Elena Petrova',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-3-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendonly' },
					{ type: 'video', status: 'sendonly' },
				],
			},
			{
				entity: 'p-3-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendonly' }],
			},
		],
	},
	{
		id: 'p-4',
		name: 'Marina Kuznetsova',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-4-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-4-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-5',
		name: 'Alex Smirnov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-5-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-5-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-6',
		name: 'Sergey Pavlov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-6-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-6-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-7',
		name: 'Dmitry Volkov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-7-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'recvonly' },
					{ type: 'video', status: 'recvonly' },
				],
			},
			{
				entity: 'p-7-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'recvonly' }],
			},
		],
	},
	{
		id: 'p-8',
		name: 'Irina Egorova',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-8-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-8-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-9',
		name: 'Roman Sokolov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-9-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-9-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-10',
		name: 'Olga Nikitina',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-10-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-10-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-11',
		name: 'Nikita Orlov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-11-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-11-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-12',
		name: 'Anna Belova',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-12-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'inactive' },
					{ type: 'video', status: 'inactive' },
				],
			},
			{
				entity: 'p-12-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'inactive' }],
			},
		],
	},
	{
		id: 'p-13',
		name: 'Yulia Markova',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-13-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-13-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-14',
		name: 'Vladimir Fedorov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-14-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-14-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-15',
		name: 'Ivan Grigoriev',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-15-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-15-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-16',
		name: 'Natalia Rudenko',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-16-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-16-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-17',
		name: 'Pavel Sorokin',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-17-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-17-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-18',
		name: 'Artem Lebedev',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-18-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-18-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-19',
		name: 'Nadezhda Krylova',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-19-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-19-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-20',
		name: 'Kirill Popov',
		state: 'full',
		status: 'connected',
		endpoints: [
			{
				entity: 'p-20-web',
				status: 'connected',
				media: [
					{ type: 'audio', status: 'sendrecv' },
					{ type: 'video', status: 'sendrecv' },
				],
			},
			{
				entity: 'p-20-phone',
				status: 'connected',
				media: [{ type: 'audio', status: 'sendrecv' }],
			},
		],
	},
	{
		id: 'p-21',
		name: 'Extra Participant',
		state: 'partial',
		status: 'pending',
		endpoints: [
			{
				entity: 'p-21-web',
				status: 'pending',
				media: [
					{ type: 'audio', status: 'recvonly' },
					{ type: 'video', status: 'recvonly' },
				],
			},
			{
				entity: 'p-21-phone',
				status: 'pending',
				media: [{ type: 'audio', status: 'recvonly' }],
			},
		],
	},
];

export const EMPTY_CAPTIONS_SRC = 'data:text/vtt,WEBVTT';

// matches GridCounter offset from bottom
export const GRID_BOTTOM_OFFSET = 100;

export const GRID_CONTROLS_BOTTOM_OFFSET = 158;

// 24px offset + 32px button size
export const GRID_CONTROLS_SIDE_OFFSET = 56;

export const GRID_GAP = 8;

export const GRID_PADDING = 16;

export const GRID_PADDING_CONTROLS: GridPadding = {
	top: GRID_PADDING,
	right: GRID_PADDING + GRID_CONTROLS_SIDE_OFFSET,
	bottom: GRID_PADDING + GRID_CONTROLS_BOTTOM_OFFSET,
	left: GRID_PADDING + GRID_CONTROLS_SIDE_OFFSET,
};

export const GRID_PADDING_CONTROLS_MOBILE: GridPadding = {
	top: GRID_PADDING,
	right: GRID_PADDING,
	bottom: GRID_PADDING + GRID_CONTROLS_BOTTOM_OFFSET,
	left: GRID_PADDING,
};

// matches GridCounter offset from bottom
export const GRID_PADDING_DEFAULT: GridPadding = {
	top: GRID_PADDING,
	right: GRID_PADDING,
	bottom: GRID_PADDING + GRID_BOTTOM_OFFSET,
	left: GRID_PADDING,
};

export const MAX_VISIBLE_CONFERENCE_USERS = 20;

export const TILE_ASPECT_RATIO = 16 / 9;

export const TILE_MIN_HEIGHT = 154;

export const TILE_MIN_WIDTH = TILE_MIN_HEIGHT * TILE_ASPECT_RATIO;
